import { writable } from "svelte/store";

let vw;
let vh;
export let width = writable("");
export let height = writable("");

export let startPageState = writable(true);
export let cardState = writable(false);
export let videoState = writable(false);
export let loadedObjects = writable(0);

function resize() {
  vw = window.innerWidth / 100;
  vh = window.innerHeight / 100;
  width.set(vw * 100);
  height.set(vh * 100);
}
window.addEventListener("resize", resize);
resize();
